import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import TasksSummary from './tasksSummary';

const enhance = compose(
  withTranslation(['tasks']),
);
export default enhance(TasksSummary);
